import styled from 'styled-components';

const FloatingWindowContent = styled.div`
  position: absolute;
  z-index: 1002;
`;

export default {
  FloatingWindowContent,
};
